import { MacroRegion } from "../../enum/MacroRegion";
import { macroRegionLimits } from "./macroRegionLimits";
import { validatePolygonInsidePolygon } from "util/validatePolygonInsidePolygon/validatePolygonInsidePolygon";
import { IMacroRegion } from "types/IMacroRegion";

export const getMacroRegionOriginFromPolygon = (
  polygonCoords: { lat: number; lng: number }[][],
  companyMacroRegions: IMacroRegion[],
  userMacroRegions: MacroRegion[] = []
): MacroRegion | null => {
  const normalizedPolygon = polygonCoords.map((ring) =>
    ring.map((coord) => [coord.lng, coord.lat])
  );

  const companyMacroRegionOrigins = companyMacroRegions?.map(
    (macroRegion) => macroRegion.origin
  );

  for (const regionKey in macroRegionLimits) {
    if (
      companyMacroRegionOrigins &&
      !companyMacroRegionOrigins.includes(regionKey)
    ) {
      continue;
    }

    if (
      userMacroRegions.length &&
      !userMacroRegions.includes(regionKey as MacroRegion)
    ) {
      continue;
    }

    const regionPolygons = macroRegionLimits[regionKey];
    const isValid = validatePolygonInsidePolygon(
      normalizedPolygon,
      regionPolygons
    );

    if (isValid) {
      return regionKey as MacroRegion;
    }
  }

  return null;
};
